var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-layout',[_c('v-flex',[_c('material-card',{attrs:{"color":"primary","title":"Lista de medicamentos"}},[_c('v-flex',[_c('medicinesCheckList')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }